import { useConfig } from "@/context/use-context";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "./api";

interface AlertResponse {
	status: "success" | "error";
	alert_id: string;
}

interface DeleteAlertParams {
	alert_id: string;
}

export const deleteAlert = async ({
	alert_id,
	BEARER_TOKEN,
	POD,
}: DeleteAlertParams & {
	BEARER_TOKEN: string;
	POD: string;
}): Promise<AlertResponse> => {
	try {
		const response = await API.delete<AlertResponse>(
			`/pods/${POD}/alerts/${alert_id}`,
			{
				headers: {
					Authorization: `Bearer ${BEARER_TOKEN}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		throw new Error(
			`Failed to delete alert: ${error instanceof Error ? error.message : "Unknown error"}`,
		);
	}
};

// React Query Hook
export const useDeleteAlert = () => {
	const config = useConfig();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (params: DeleteAlertParams) =>
			deleteAlert({
				...params,
				BEARER_TOKEN: config.bearerToken,
				POD: config.pod?.pod_id ?? "",
			}),
		onSuccess: () => {
			// Invalidate and refetch alerts data
			queryClient.invalidateQueries({ queryKey: ["alertData"] });
		},
		onError: (error) => {
			console.error("Error deleting alert:", error);
		},
	});
};
